<template>
  <div class="plaid-link-wrapper">
    <slot name="button">
      <div class="plaid-link-button" @click="handleOnClick">
        <slot />
      </div>
    </slot>
  </div>
</template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";

export default Vue.component("PlaidLink", {
  props: {
    plaidUrl: VueTypes.string.def(
      "https://cdn.plaid.com/link/v2/stable/link-initialize.js"
    ),
    env: VueTypes.string.def("sandbox"),
    institution: VueTypes.string,
    selectAccount: VueTypes.string,
    token: VueTypes.string,
    product: VueTypes.string.def("transactions"),
    clientName: VueTypes.string,
    publicKey: VueTypes.string,
    webhook: VueTypes.string,
    onSuccess: VueTypes.func,
    onExit: VueTypes.func,
    onEvent: VueTypes.func
  },

  created() {
    this.loadScript(this.plaidUrl)
      .then(this.onScriptLoaded)
      .catch(this.onScriptError);
  },

  data() {
    return {
      linkHandler: null
    };
  },

  methods: {
    onScriptError(error) {
      console.error(
        "There was an issue loading the link-initialize.js script ->>> ",
        error
      );
    },

    onScriptLoaded() {
      if (!window.Plaid) {
        console.info("Plaid is starting...");
        return;
      }

      console.info("Plaid has been loaded!");
    },

    handleOnClick() {
      const handler = window.Plaid.create({
        clientName: this.clientName,
        env: this.env,
        key: this.publicKey,
        onExit: this.onExit,
        onEvent: this.onEvent,
        onSuccess: this.onSuccess,
        product: this.product,
        apiVersion: "v2",
        selectAccount: this.selectAccount,
        token: this.token,
        webhook: this.webhook
      });

      if (handler) {
        handler.open();
      }

      this.linkHandler = handler;
    },

    loadScript(src) {
      return new Promise(function(resolve, reject) {
        if (document.querySelector('script[src="' + src + '"]')) {
          resolve();
          return;
        }
        const el = document.createElement("script");
        el.type = "text/javascript";
        el.async = true;
        el.src = src;
        el.addEventListener("load", resolve);
        el.addEventListener("error", reject);
        el.addEventListener("abort", reject);
        document.head.appendChild(el);
      });
    }
  },

  beforeDestroy() {
    if (this.linkHandler) {
      this.linkHandler.exit();
    }
  }
});
</script>

<style lang="scss" scoped>
.plaid-link-button {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
</style>

<style lang="scss">
div#plaid-link-container {
  .Overlay {
    background-color: rgba(0, 0, 0, 0.3);

    &__content {
      width: 50%;
      height: 50%;
    }
  }
}
</style>
